function getStorage(): Storage | undefined {
  if (typeof window === 'undefined') return undefined
  return window.sessionStorage
}

/** sessionStorage can throw (private mode / quota); never let that abort Search. */
export function safeStorageSetItem(key: string, value: string): void {
  try {
    getStorage()?.setItem(key, value)
  } catch {
    // ignore
  }
}

export function safeStorageRemoveItem(key: string): void {
  try {
    getStorage()?.removeItem(key)
  } catch {
    // ignore
  }
}

export function safeStorageGetItem(key: string): string | undefined {
  try {
    return getStorage()?.getItem(key) ?? undefined
  } catch {
    return undefined
  }
}
